import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import BlogIntroduction from "./sections/BlogIntroduction";
import LatestArticles from "./sections/LatestArticles";
import ExploreTopics from "./sections/ExploreTopics";
import StayConnected from "./sections/StayConnected";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <BlogIntroduction />
      <LatestArticles />
      <ExploreTopics />
      <StayConnected />
      <Footer />
    </div>;
}